<div id="top"></div>
<app-navbar></app-navbar>
<br>

<!-- *ngIf="showMsg" class="break-msg" -->
<!-- <div class="row"   [hidden]="!submitted">
    <div class="col-md-8 offset-md-2">
        <p class="alert alert-success"> 
            Your subscription is successfully submitted; your response will be reviewed within 2 to 4 business days by Aetna’s Interoperability team. Our team will reach out to you for any additional questions.
        </p>
    </div>
</div> -->
 <div class="row" [hidden]="!submitted"> 
    <div class="col-md-2">

    </div>
    <div class="col-md-8"  >
        <mat-card>
        <div class="col-md-12 px-0 ">
            <p class="aetnaMainDiv"  style="word-break: break-word;"> 
                <span class="status-qualified">  
                Your subscription is successfully submitted; your response will be reviewed within 2 to 4 business days by Aetna’s Interoperability team. Our team will reach out to you for any additional questions.
                </span>
                <br>
            </p>
          
        </div> 
    </mat-card>
    </div>
    <div class="col-md-2">

    </div>
</div> 

<div [hidden]="submitted">
<div style="background-color:#f5f5f5;width:99%" class="mx-auto d-block">
    <div style="background-color:#f5f5f5;width:100%" class="mx-auto d-block">
        <div class="container-fluid" style="width: 99%">
        <div class="row"> 
            
            <div class="col-md-4">
                <br>
                 <p-panel   [style]="{'margin-bottom':'20px'}">
           
                   <p-header>
                     <div class="ui-helper-clearfix">
                      <h2>   <span class="ui-panel-title" style="font-size: 22px;display:inline-block;margin-top:2px;font-weight: 500;">My Profile </span> </h2>     
                       </div>
                    </p-header>
                            <div class="container-fluid">
                            <div class="row" >
                            <div class="col-md-6">
                                      <label  class="text-break aetna-table-header">First Name  :<br/> {{firstNameDisplay}} </label>
                                       <hr>
                                      </div>
                          <div class="col-md-6">
                           <label  class="text-break aetna-table-header">Last Name :<br/> {{lastNameDisplay}}</label>
                               <hr>
                       </div>
                       <div class="col-md-12">
                           <label  style="word-break: break-all" class="text-break aetna-table-header">Email ID :<br/> {{emailIdDisplay}} </label>
                               <hr>
                           </div>
                         </div>
                       </div >
                 </p-panel>
                 <br>
                 <div class="toast fade show" role="alert" aria-live="assertive" aria-atomic="true" *ngIf="reamrks_soft">
                    <div class="toast-header">
                    
                      <strong class="mr-auto">Remarks</strong>
                     
                      
                    </div>
                    <div class="toast-body" >
                   
                      <div style="color: red;font-size: 16px;">
                          <i class="pi pi-minus-circle" style="font-size: 1em;color: #7d3f98;"></i>
                          &nbsp; 
                         {{reamrks_soft}}
            
                       
                          <br>
                          <br>
                        </div>
                       
            
                    </div>
                  </div> 

            </div>

            <div class="col-md-8">
            <br/> 

                <p-panel>
                        <p-header>
                            <div class="ui-helper-clearfix">
                                <!-- <h2> <span class="ui-panel-title"
                                        style="font-size: 22px;display:inline-block;margin-top:2px;font-weight: 500;">Please
                                        Fill Below Questionnaire to begin process of subscribing to Aetna's Interoperability API
                                        Developer Portal Sandbox or our production APIs </span> </h2> -->
                                <h3 style="text-align: center; font-weight: bold;">Payer Questionnaire</h3>
                            </div>
                        </p-header>
                    <!-- [hidden]="submitted" -->
                    
                        <!-- #questionnaireForm="ngForm" autocomplete="off"  [formGroup]="payerQuestionnaireForm" -->
                    <form #payerQuestionnaireForm="ngForm" name="form"  (ngSubmit)="payerQuestionnaireForm.form.valid && onSubmit()" novalidate>
                        <div class="ui-fluid container-fluid col-md-11" style="background: rgb(255, 255, 255);">
                            <div class="row questionnaire-ui">

                                <!-- <div class="row"  *ngIf="showMsg">
                                    <div class="col-xs-12">
                                        <p class="alert alert-success"> 
                                            Your subscription is successfully submitted; your response will be reviewed within 2 to 4 business days by Aetna’s Interoperability team. Our team will reach out to you for any additional questions.
                                        </p>
                                    </div>
                                </div>  -->

                                <div class="form-group p-field col-md-12">
                                    <br>
                                    <label for="payerName" class="">Name of Payer Entity <span style="color: red; font-weight: bold;">*</span></label>
                                    <div *ngIf="payerName.touched">
                                            <div *ngIf="payerName.errors?.pattern" class="text-danger">* Name of the Payer Entity only accepts letters A through Z ,numbers 0 through 9, ampersand (&) hyphen (-)</div> 
                                            <div *ngIf="payerName.errors?.required"  class="text-danger">* Please enter Name of Payer Entity</div> 
                                    </div>
                                    <input (blur)="userValues.payerName= userValues.payerName.trim();" type="text" class="form-control" #payerName='ngModel' [(ngModel)]="userValues.payerName" name="payerName" pattern="[-a-zA-Z\s0-9&-]+([-a-zA-Z]+)*$" minlength="1" maxlength="80" required>
                                </div>
                                <div class="form-group p-field col-md-12">
                                    <br>
                                    <label for="parentCompanyname"> Name of Parent Company (if applicable) </label>
                                    <input type="text" class="form-control" id="parentCompanyname" name="parentCompanyname" [(ngModel)]="userValues.parentCompanyname" (blur)="userValues.parentCompanyname= userValues.parentCompanyname.trim();" pattern="^[^\s]+(\s+[^\s]+)*$" minlength="1" maxlength="80" >
                                </div>
  
                                <div class="form-group p-field col-md-12">
                                    <br>
                                    <label for="registrantName">Registrant First Name <span style="color: red; font-weight: bold;">*</span></label>
                                     <!-- <div *ngIf="registrantName.invalid && registrantName.touched || registrantName.invalid && registrantName.maxlength || registrantName.invalid && registrantName.minlength" class="text-danger">* Please enter Registrant's name</div>  -->
                                    <div *ngIf="registrantName.touched">
                                        <div *ngIf="registrantName.errors?.required" class="text-danger">* Please enter Registrant First Name</div> 
                                        <div *ngIf="registrantName.errors?.pattern"  class="text-danger">* Registrant First Name can only contain Letters</div> 
                                       
                                    </div>
                                    
                                    <input type="text" class="form-control" name="registrantName" #registrantName='ngModel' [(ngModel)]="firstName" (blur)="firstName= firstName.trim();" pattern="[-a-zA-Z\s]+([-a-zA-Z]+)*$"  minlength="1" maxlength="80" required>
                                    
                                </div>

                                <div class="form-group p-field col-md-12">
                                    <br>
                                    <label for="registrantLastName">Registrant Last Name <span style="color: red; font-weight: bold;">*</span></label>
                                     <!-- <div *ngIf="registrantName.invalid && registrantName.touched || registrantName.invalid && registrantName.maxlength || registrantName.invalid && registrantName.minlength" class="text-danger">* Please enter Registrant's name</div>  -->
                                    <div *ngIf="registrantLastName.touched">
                                        <div *ngIf="registrantLastName.errors?.required" class="text-danger">* Please enter Registrant Last Name</div> 
                                        <div *ngIf="registrantLastName.errors?.pattern"  class="text-danger">* Registrant Last Name can only contain Letters</div> 
                                       
                                    </div>
                                    
                                    <input type="text" class="form-control" name="registrantLastName" #registrantLastName='ngModel' [(ngModel)]="lastName" (blur)="lastName= lastName.trim();" pattern="[-a-zA-Z\s]+([-a-zA-Z]+)*$"  minlength="1" maxlength="80" required>
                                    
                                </div>
                                
                                <div class="form-group p-field col-md-12">
                                    <br>
                                    <label for="registrantRole">Registrant's role within the company. <span style="color: red; font-weight: bold;">*</span></label>
                                   <!--  <div *ngIf="registrantRole.invalid && registrantRole.touched || registrantRole.invalid && registrantRole.maxlength || registrantRole.invalid && registrantRole.minlength" class="text-danger">* Please enter Registrant's role within the company</div> -->
                                    <div *ngIf="registrantRole.touched">
                                        <div *ngIf="registrantRole.errors?.required" class="text-danger">* Please enter Registrant's role within the company</div> 
                                        
                                    </div>
                                   <input type="text" class="form-control" #registrantRole='ngModel' [(ngModel)]="userValues.registrantRole" (blur)="userValues.registrantRole= userValues.registrantRole.trim();" name="registrantRole" pattern="[-a-zA-Z\s0-9`~!@#$%^&*()-_=+{}\|;:',.?]+([-a-zA-Z]+)*$" minlength="1" maxlength="80" required>
                                </div>

                            <ng-form #multipleContact="ngForm" name="form">
                            <div class="col-12">
                                <p-fieldset legend="Add Contacts">
                                    <div class="row g-3">

                                <div class="col-12">
                                    <br>
                                    <label for="contactName" style="color: #7d3f98">Contact First and Last Name<span style="color: red; font-weight: bold;">*</span></label>
                                   <!--  <div *ngIf="contactName.invalid && contactName.touched || contactName.invalid && contactName.maxlength || contactName.invalid && contactName.minlength" class="text-danger">* Please enter Contact Name</div> -->
                                   <div *ngIf="contactName.touched">
                                        <div *ngIf="contactName.errors?.required" class="text-danger">* Please enter Contact First and Last Name</div> 
                                        <div *ngIf="contactName.errors?.pattern"  class="text-danger">* Contact First and Last Name can only contain Letters</div> 
                                    </div>
                                   <input type="text" class="form-control" #contactName='ngModel' [(ngModel)]="userValues.contactName" (blur)="userValues.contactName= userValues.contactName.trim();" name="contactName" pattern="[-a-zA-Z\s]+([-a-zA-Z]+)*$" minlength="1" maxlength="80" required>
                                </div>
                                
                                <div class="col-12" style="color: #7d3f98">
                                    <br>
                                    <label for="email">Contact Business Email <span style="color: red; font-weight: bold;">*</span></label>
                                    <!-- <div *ngIf="email.invalid && email.touched || email.invalid && email.minlength || email.invalid && email.maxlength || email.invalid && email.pattern" class="text-danger">* Your email address should look like: name@domain.com</div> -->
                                    <div *ngIf="email.touched">
                                        <div *ngIf="email.errors?.required" class="text-danger">* Please enter Contact Business Email</div> 
                                        <!-- <div *ngIf="email.errors?.pattern"  class="text-danger">* Your Email Address should look like: name@domain.com</div>  -->
                                        <div *ngIf="email.errors?.pattern"  class="text-danger">* Please enter valid Contact Business Email</div> 
                                    </div>
                                    <!-- <input type="text" class="form-control" #email='ngModel' [(ngModel)]="userValues.email" name="email" pattern="[a-zA-Z0-9._]+@+[a-zA-Z]+\.[a-z]{2,4}$" minlength="1" maxlength="80" required> -->
                                    <input type="text" class="form-control" #email='ngModel' [(ngModel)]="userValues.email"  (blur)="userValues.email= userValues.email.trim();"  name="email" pattern="^\S+@\S+$" minlength="1" maxlength="80" required>
                                </div>
                                <!-- <div class="form-group p-field col-md-12">
                                    <br>
                                    <label for="role">Contact Telephone Number

                                        <span style="color: red; font-weight: bold;">*</span></label>
                                    <input type="text" class="form-control" id="telephone" name="telephone"
                                        [(ngModel)]="userValues.telephone" pattern="[789][0-9]{9}"
                                        placeholder="Enter telephone number without country code or '0'" required>
                                    
                                </div> -->
                                <div class="col-6" style="color: #7d3f98">
                                    <br>
                                    <label for="countryCode">Country Code<span style="color: red; font-weight: bold;">*</span></label>
                                    
                                        <!-- <div *ngIf="countryCode.invalid && countryCode.touched" class="text-danger">* Please select your Country code</div>  -->
                                        <div *ngIf="countryCode.touched">
                                            <div *ngIf="countryCode.errors?.required" class="text-danger">* Please select your Country code</div> 
                                           
                                        </div>   
                                        <select class="form-control" name="countryCode" #countryCode='ngModel' [(ngModel)]="userValues.countryCode" required>
                                            <option value="" disabled selected>Select Country</option>
                                            <option *ngFor="let country of countries" [value]="country.code3">{{country.name + "-" + country.number}}
                                                </option>
                                        </select>
                                                                                                     
                                </div>
        
                                <div class="col-6" style="color: #7d3f98">
                                    <br>
                                    <label for="telephone">Telephone Number<span style="color: red; font-weight: bold;">*</span></label>                            
                                    <!-- <div *ngIf="telephone.invalid && telephone.touched" class="text-danger">* Please enter 10 Digit Telephone Number</div>  -->
                                    <div *ngIf="telephone.touched">
                                        <div *ngIf="telephone.errors?.required" class="text-danger">* Please enter 10 Digit Telephone Number</div> 
                                       
                                    </div>
                                    <p-inputMask unmask=true  name="telephone" mask="(999) 999-9999"  #telephone='ngModel'  (blur)="userValues.telephone= userValues.telephone.trim();"  [(ngModel)]="userValues.telephone" required></p-inputMask>
                                 </div> 

                                 <div class="p-field col-md-6">
                                    <br>
                                    <button pButton (click)="addMultipleRequest()" [disabled]="multipleContact.invalid"  label="Add" type="button"
                                     class="aetna-button ui-button-raised ui-button-rounded"></button>
                  
                                  </div>
                                  <div style="word-break: break-word;" class="col-12">
                                    <br>
                                   <!--  <div *ngIf="duplicateContacts" class="text-danger text-center">* Duplicate Contacts can not be added</div> -->
                                    <p-table #tt *ngIf="DisplayMultipleRequest" [columns]="MultipleRequestCols" [value]="MultipleRequest" [style]="{width: '100%'}"  [responsive]="true" [rows]="5">
                                      <ng-template pTemplate="header" let-columns >
                                          <tr>
                                              <th style="color: #7d3f98"> Contact Name </th>
                                              <th style="color: #7d3f98"> Contact Business Email </th>                 
                                              <th style="color: #7d3f98"> Country Code </th>                                             
                                              <th style="color: #7d3f98"> Telephone Number</th>
                                              <th style="color: #7d3f98"> Remove</th>
                                              <th style="color: #7d3f98"> Edit</th>
                                          </tr>
                                      </ng-template>
                                     <!--  <tr *ngFor="let cart of modalData;let i = index"></tr> let-rowData -->
                                      <ng-template pTemplate="body"  let-rowData let-columns="columns">
                                          <tr>
                                            <td class="text-break">
                                              {{rowData['contactName']}}
                                          </td>
                                              <td class="text-break">
                                                {{rowData['contactBusinessEmailText']}}
                                            </td>
                                            <td class="text-break">
                                              {{rowData['countryCode']}}
                                          </td>
                                          <td class="text-break">
                                            {{rowData['contactTelephoneNumber']}}
                                         </td>
                                            <td > 
                                                <button pButton icon="pi pi-trash" type="button" class="aetna-button ui-button-raised ui-button-rounded" id="remove" (click)="deleteRow(rowData)"> </button>
                                            </td> 
                                            <td > 
                                                <button pButton icon="pi pi-user-edit" type="button"   class="aetna-button ui-button-raised ui-button-rounded" (click)="editContact(rowData)" > </button>
                                            </td> 
                                          </tr>
                                      </ng-template>
                                  </p-table>
                                        
                                   </div>
                                    </div>
                                </p-fieldset>
                            </div>
                            </ng-form>

                            <div class="form-group p-field col-md-12">
                                <br>
                                <label for="country">In what country is your organization domiciled? <span style="color: red; font-weight: bold;">*</span></label>
                                <!-- <div *ngIf="country.invalid && country.touched" class="text-danger">* Please select In what country is your organization domiciled?</div> -->
                                <div *ngIf="country.touched">
                                    <div *ngIf="country.errors?.required" class="text-danger">* Please select In what country is your organization domiciled?</div> 
                                   
                                </div> 
                                <select class="form-control" name="country" #country='ngModel' [(ngModel)]="userValues.country"  required>
                                    <option value="" disabled selected>Select Country</option>
                                    <option *ngFor="let country of countries" [value]="country.name">{{country.name}} </option>
                                </select>
                            </div>
                        
                            <div class="form-group p-field col-md-12">
                                <br>
                                <label for="storagecountry">In what country would member PHI data be stored? <span style="color: red; font-weight: bold;">*</span></label>
                                <!-- <div *ngIf="storagecountry.invalid && storagecountry.touched" class="text-danger">* Please select In what country would member PHI data be stored? </div> -->
                                <div *ngIf="storagecountry.touched">
                                    <div *ngIf="storagecountry.errors?.required" class="text-danger">* Please select In what country would member PHI data be stored?</div> 
                                   
                                </div> 
                                <select class="form-control" name="storagecountry" #storagecountry='ngModel' [(ngModel)]="userValues.storagecountry" required>
                                    <option value="" disabled selected>Select Country</option>
                                    <option *ngFor="let country of countries" [value]="country.name">{{country.name}} </option>
                                </select>
                            </div>

                                
                                <div class="form-group p-field col-md-12">
                                    <br>
                                    <label for="domainlist">Please list all domain names that you plan to use to connect with our infrastructure. <span style="color: red; font-weight: bold;">*</span> </label>
                                    <!-- <div *ngIf="domainlist.invalid && domainlist.touched || domainlist.invalid && domainlist.minlength || domainlist.invalid && domainlist.maxlength" class="text-danger">* Please enter list all of the domain names that you plan to use to connect with our infrastructure</div> -->
                                    <div *ngIf="domainlist.touched">
                                        <div *ngIf="domainlist.errors?.required" class="text-danger">* Please enter list all of the domain names that you plan to use to connect with our infrastructure</div> 
                                        
                                    </div>
                                    <textarea rows="6" cols="80" class="form-control" #domainlist='ngModel' [(ngModel)]="userValues.domainlist"  (blur)="userValues.domainlist= userValues.domainlist.trim();" name="domainlist" pattern="[-a-zA-Z\s0-9`~!@#$%^&*()-_=+{}\|;:',.?]+([-a-zA-Z]+)*$" minlength="1" maxlength="1000" required>
                                    </textarea>
                                    </div>
                                <!-- <div class="p-field col-md-12">
                                    <br>
                                    <label for="securityPracticesResponse">Do you agree to follow common security practices such as OWASP Top 10 and SANS Top 25? <span style="color: red; font-weight: bold;">*</span> </label>
                                    <div *ngIf="securityPracticesResponse.invalid && securityPracticesResponse.touched" class="text-danger">Please select an option, Do you agree to follow common security practices such as OWASP Top 10 and SANS Top 25? </div>
                                    <p-dropdown class="form-control" #securityPracticesResponse='ngModel' ngModel [options]="securitypractices" name="securitypractices" placeholder="Please Select an Option" required> </p-dropdown>
                                </div> -->

                                <div class="form-group p-field col-md-12">
                                    <br>
                                    <label for="securitypractices">Do you agree to follow common security practices such as OWASP Top 10 and SANS Top 25? <span style="color: red; font-weight: bold;">*</span></label>
                                    <!-- <div *ngIf="securitypractices.invalid && securitypractices.touched" class="text-danger">* Please select an option, Do you agree to follow common security practices such as OWASP Top 10 and SANS Top 25? </div> -->
                                    <div *ngIf="securitypractices.touched">
                                        <div *ngIf="securitypractices.errors?.required" class="text-danger">* Please select an option, Do you agree to follow common security practices such as OWASP Top 10 and SANS Top 25?</div> 
                                         
                                    </div>
                                    <select class="form-control" name="securitypractices" placeholder="Please select an option" #securitypractices='ngModel' [(ngModel)]="userValues.securitypractices" required>
                                        <option value="" disabled selected>Please select an option</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>
      
                                <div class="form-group p-field col-md-12">
                                    <br>
                                    <label for="review">Are your application standards regularly reviewed (at least annually) to account for changes in environment, available security features and/or leading practices? <span style="color: red; font-weight: bold;">*</span> </label>
                                    <!-- <div *ngIf="review.invalid && review.touched" class="text-danger">* Please select an option,Are your application standards regularly reviewed (at least annually) to account for changes in environment, available security features and/or leading practices? </div> -->
                                    <div *ngIf="review.touched">
                                        <div *ngIf="review.errors?.required" class="text-danger">* Please select an option,Are your application standards regularly reviewed (at least annually) to account for changes in environment, available security features and/or leading practices?</div> 
                                         
                                    </div>
                                    <select class="form-control" name="review" placeholder="Please select an option" #review='ngModel' [(ngModel)]="userValues.review" required>
                                        <option value="" disabled selected>Please select an option</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>

                                <div class="form-group p-field col-md-12">
                                    <br>
                                    <label for="consent">Will you obtain member’s consent prior to obtaining data from Aetna’s Payer to Payer API? <span style="color: red; font-weight: bold;">*</span></label>
                                   <!--  <div *ngIf="consent.invalid && consent.touched" class="text-danger">* Please select an option,Will you obtain member’s consent prior to obtaining data from Aetna’s Payer to Payer API?</div> -->
                                    <div *ngIf="consent.touched">
                                        <div *ngIf="consent.errors?.required" class="text-danger">* Please select an option,Will you obtain member’s consent prior to obtaining data from Aetna’s Payer to Payer API?</div> 
                                         
                                    </div>
                                    <select class="form-control" name="consent" placeholder="Please select an option" #consent='ngModel' [(ngModel)]="userValues.consent" required>
                                        <option value="" disabled selected>Please select an option</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                    
                                </div>
                                <div class="form-group p-field col-md-12">
                                    <br>
                                    <label for="FHIRStandards">Will you use FHIR standards to invoke payer data exchange APIs? If not, please explain what standards will be used. <span style="color: red; font-weight: bold;">*</span></label>
                                   <!--  <div *ngIf="FHIRStandards.invalid && FHIRStandards.touched || FHIRStandards.invalid && FHIRStandards.minlength || FHIRStandards.invalid && FHIRStandards.maxlength" class="text-danger">* Please enter, Will you use FHIR standards to invoke payer data exchange APIs? If not, please explain what standards will be used</div> -->
                                    <div *ngIf="FHIRStandards.touched">
                                        <div *ngIf="FHIRStandards.errors?.required" class="text-danger">* Please enter, Will you use FHIR standards to invoke payer data exchange APIs? If not, please explain what standards will be used</div> 
                                        
                                    </div>
                                    <textarea rows="6" cols="80" class="form-control" #FHIRStandards='ngModel' [(ngModel)]="userValues.FHIRStandards"   (blur)="userValues.FHIRStandards= userValues.FHIRStandards.trim();" name="FHIRStandards" pattern="[-a-zA-Z\s0-9`~!@#$%^&*()-_=+{}\|;:',.?]+([-a-zA-Z]+)*$" minlength="1" maxlength="600" required>
                                    </textarea>
                                </div>


                                <div class="p-field col-md-12">
                                    <div *ngIf="payerQuestionnaireForm.submitted && payerName.invalid">
                                        <div *ngIf="payerName.errors.required" class="text-danger">* Please enter Name of Payer Entity</div>
                                    </div>
                                    <div *ngIf="payerQuestionnaireForm.submitted && registrantName.invalid">
                                        <div *ngIf="registrantName.errors.required" class="text-danger">* Please enter Registrant First Name</div>
                                    </div>
                                    <div *ngIf="payerQuestionnaireForm.submitted && registrantLastName.invalid">
                                        <div *ngIf="registrantLastName.errors.required" class="text-danger">* Please enter Registrant Last Name</div>
                                    </div>
                                    <div *ngIf="payerQuestionnaireForm.submitted && registrantRole.invalid">
                                        <div *ngIf="registrantRole.errors.required" class="text-danger">* Please enter Registrant's role within the company</div>
                                    </div>
                                    <div *ngIf="payerQuestionnaireForm.submitted && country.invalid">
                                        <div *ngIf="country.errors.required" class="text-danger">* Please select In what country is your organization domiciled?</div>
                                    </div>
                                    <div *ngIf="payerQuestionnaireForm.submitted && storagecountry.invalid">
                                        <div *ngIf="storagecountry.errors.required" class="text-danger">* Please select In what country would member PHI data be stored?</div>
                                    </div>
                                    
                                   <div *ngIf="payerQuestionnaireForm.submitted">
                                        <div *ngIf="contactArray" class="text-danger">* Please add atleast one Contact</div>
                                    </div>
                                    <!-- <div [hidden]="!contactArray">
                                        <div class="text-danger">* Please add atleast one Contact</div>
                                    </div> -->
                                    <!-- <div *ngIf="payerQuestionnaireForm.submitted && contactName.invalid">
                                        <div *ngIf="contactName.errors.required" class="text-danger">* Please enter Contact Name</div>
                                    </div>
                                    <div *ngIf="payerQuestionnaireForm.submitted && email.invalid">
                                        <div *ngIf="email.errors.required" class="text-danger">* Please enter Contact Business Email</div>
                                    </div>
                                    <div *ngIf="payerQuestionnaireForm.submitted && countryCode.invalid">
                                        <div *ngIf="countryCode.errors.required" class="text-danger">* Please select your Country code</div>
                                    </div>
                                    <div *ngIf="payerQuestionnaireForm.submitted && telephone.invalid">
                                        <div *ngIf="telephone.errors.required" class="text-danger">* Please enter Telephone number</div>
                                    </div> --> 
                                    <div *ngIf="payerQuestionnaireForm.submitted && domainlist.invalid">
                                        <div *ngIf="domainlist.errors.required" class="text-danger">* Please enter list all of the domain names that you plan to use to connect with our infrastructure</div>
                                    </div>
                                    <div *ngIf="payerQuestionnaireForm.submitted && securitypractices.invalid">
                                        <div *ngIf="securitypractices.errors.required" class="text-danger">* Please select an option, Do you agree to follow common security practices such as OWASP Top 10 and SANS Top 25?</div>
                                    </div>
                                    <div *ngIf="payerQuestionnaireForm.submitted && review.invalid">
                                        <div *ngIf="review.errors.required" class="text-danger">* Please select an option,Are your application standards regularly reviewed (at least annually) to account for changes in environment, available security features and/or leading practices? </div>
                                    </div>
                                    <div *ngIf="payerQuestionnaireForm.submitted && consent.invalid">
                                        <div *ngIf="consent.errors.required" class="text-danger">* Please select an option,Will you obtain member’s consent prior to obtaining data from Aetna’s Payer to Payer API?</div>
                                    </div>
                                    <div *ngIf="payerQuestionnaireForm.submitted && FHIRStandards.invalid">
                                        <div *ngIf="FHIRStandards.errors.required" class="text-danger">* Please enter, Will you use FHIR standards to invoke payer data exchange APIs? If not, please explain what standards will be used</div>
                                    </div>
                                </div>
                                

                            
                                <div class=" p-field col-md-3"></div>

                                <div class=" p-field col-md-3 offset-md-1">
                                    <!-- #submit label="Submit"
                                        onclick="window.location.reload();"  [disabled]="payerQuestionnaireForm.invalid"   #submit (click)= "createnewApp()"  -->
                                    <br> 
                                    <button pButton type="submit" label="Submit" class="aetna-button ui-button-raised ui-button-rounded"></button>
                                    <br><br>
                                </div>
                                <div class=" p-field col-md-3"></div>
                                <br>

                            </div>
                        </div>
                    </form>
                    
                    <!-- <div [hidden]="!submitted">
                        <div class="row">
                            <div class="col-md-11">
                                <b > 
                                    Your subscription is successfully submitted; your response will be reviewed within 2 to 4 business days by Aetna’s Interoperability team. Our team will reach out to you for any additional questions.
                                </b>
                            </div>
                        </div>
                    </div> -->
                     
                </p-panel>
        </div>
        </div> 
        </div>
    </div>

</div>
</div>

<p-dialog [modal]="true" [closable]="false" header="Please Wait" [(visible)]="showSpiner" [style]="{width: '50vw'}" >
        
    <div class="container-fluid" style="width:99%" >
      <div class="row" >
        <div class="col-md-5">
        </div>
        <div class="col-md-2" >
            <p-progressSpinner  [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
        </div>
        <div class="col-md-5">
  
        </div>
      </div> 
    </div>
</p-dialog>